import React, { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Divider,
} from '@mui/material';
import api from '../utils/api';
import Loader from '../components/Loader';
import { snackbar } from '../utils/showMessage';

const BoardMembers = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBoardMembers();
  }, []);

  const fetchBoardMembers = async () => {
    try {
      setLoading(true);
      const response = await api.get('/board-members');
      setMembers(response.data);
    } catch (error) {
      console.error('Error fetching board members:', error);
      snackbar('خطا در بارگذاری لیست اعضای هیئت مدیره');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <Container className="main-container pt-3 pb-5">
      <Box mb={4} textAlign="center">
        <Typography variant="h5" component="h1" gutterBottom fontWeight="bold" sx={{ mt: 2 }}>
          اعضای هیئت مدیره
        </Typography>
        <Divider sx={{ width: '60px', margin: '0 auto', borderBottomWidth: 3, bgcolor: 'primary.main', mb: 3 }} />
      </Box>

      <Grid container spacing={3}>
        {members.map((member, index) => (
          <Grid 
            item 
            xs={12} 
            sm={index === 0 ? 12 : 6} 
            md={index === 0 ? 12 : 4} 
            key={member._id}
          >
            <Card sx={{ 
              borderRadius: '20px', 
              boxShadow: '0 8px 24px rgba(0,0,0,0.05)',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              pt: 3,
              transition: 'transform 0.2s',
              maxWidth: index === 0 ? { md: '600px', sm: '100%' } : '100%',
              margin: '0 auto',
              '&:hover': {
                transform: 'translateY(-5px)'
              }
            }}>
              <CardMedia
                component="img"
                sx={{ 
                  width: index === 0 ? 160 : 120, 
                  height: index === 0 ? 160 : 120, 
                  borderRadius: '50%',
                  objectFit: 'cover',
                  border: '4px solid #f0f0f0'
                }}
                image={member.image ? (member.image.startsWith('http') ? member.image : `${process.env.REACT_APP_FILE_BASE_URL}${member.image}`) : "/assets/img/user1.jpg"}
                alt={member.name}
                onError={(e) => { e.target.src = "/assets/img/user1.jpg" }}
              />
              <CardContent sx={{ textAlign: 'center', flexGrow: 1 }}>
                <Typography variant={index === 0 ? "h5" : "h6"} fontWeight="bold" gutterBottom>
                  {member.name}
                </Typography>
                <Typography variant="body1" color="primary" gutterBottom>
                  {member.title}
                </Typography>
                {member.description && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {member.description}
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      
      {members.length === 0 && (
        <Box textAlign="center" mt={4}>
          <Typography color="text.secondary">موردی یافت نشد.</Typography>
        </Box>
      )}
    </Container>
  );
};

export default BoardMembers;
